module.exports = __webpack_public_path__ + "static/media/sort-size-down-alt.7ef38ef0.svg";